module.exports = __webpack_public_path__ + "static/5-d1991ddd9ff304ec04a6655841897370.png";